module.exports = __webpack_public_path__ + "static/media/cq_ok.4a37121e.svg";